import { TLayoutContextValues } from "app/context/LayoutContext/types";
import { theme } from "kosmos-ui/lib";
import { CSSProperties } from "react";
import styled from "styled-components";

export const HomeIntroContainer = styled.section<{ headerHeight: number }>`
  background-color: ${({ theme }) => theme.colorsPalette.black.darker};
  min-height: 33vh;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: ${({ headerHeight }) => `calc(72px + ${headerHeight}px)`} 72px 0 72px;

  @media (max-width: 600px) {
    height: 50vh;
    padding: ${({ headerHeight }) => `calc(32px + ${headerHeight}px)`} 24px 16px
      24px;
  }
`;

export const HomeIntroHeader = styled.header`
  display: flex;
  margin: 0 auto;
  max-width: 1200px;
  width: 100%;
  height: 100%;
  align-items: center;
`;

export function getHomeIntroHeaderStyles(
  props: Pick<TLayoutContextValues, "mobile">
): CSSProperties {
  let style: CSSProperties = {
    color: theme.colorsPalette.white.default,
    width: "100%",
    margin: !props.mobile ? "0 72px" : 0,
    position: "absolute",
    zIndex: 1,
    maxWidth: props.mobile ? 244 : 760,
  };

  if (props.mobile) style = { ...style, padding: 24 };

  return style;
}
